module.exports = __webpack_public_path__ + "img/Loading_xh_10.d34091d5.png";